import React from 'react'
import { connect } from 'react-redux'

import './export.css'
import Export from './Export'
import { fetchExport } from './jobs-reducer'

const ExportContainer = ({
  jobsExport,
  fetchExport,
  isExportRequestOngoing
}) => {
  return <Export
    onExport={fetchExport}
    isExportRequestOngoing={isExportRequestOngoing}
  />
}

const mapStateToProps = ({ jobs: {
  jobsExport,
  isExportRequestOngoing
}}) => ({
  jobsExport,
  isExportRequestOngoing
})

export default connect(mapStateToProps, { fetchExport })(ExportContainer)



// WEBPACK FOOTER //
// ./src/jobs/ExportContainer.js